import React from 'react';
import { PageHero } from '../components/PageHero';
import { Evidence as EvidenceSection } from '../components/Evidence';
import { Missions } from '../components/Missions';
import { Safety } from '../components/Safety';
import { SectionStage } from '../components/SectionStage';
export function Evidence() {
  return <>
      <PageHero eyebrow="Evidence" title="Proof your team," titleMuted="customers, and auditors trust." description="Every validated path becomes evidence — shareable, exportable, and audit-ready. From technical detail to executive summary in one place." bg="none" data-id="element-1499" />
      <SectionStage fx="squares" data-id="element-1500">
        <EvidenceSection data-id="element-1501" />
      </SectionStage>
      <SectionStage fx="orbit" data-id="element-1502">
        <Missions data-id="element-1503" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1504">
        <Safety data-id="element-1505" />
      </SectionStage>
    </>;
}